module.exports = __webpack_public_path__ + "static/media/multiplex20.cf5e09c1.png";